import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import { t } from 'ttag'
import { Link } from 'react-router-dom'

import pagearrow from '@h2/assets/svg/icons/pageArrow.svg'

import TextQuestionForm from './questiontypes/TextQuestionForm'
import RatingQuestionForm from './questiontypes/RatingQuestionForm'
import MultipleChoiceQuestionForm from './questiontypes/MultipleChoiceQuestionForm'
import MultipleChoiceOccupationForm from './questiontypes/MultipleChoiceOccupationForm'
import MultipleChoiceEducationalInstitutionForm from './questiontypes/MultipleChoiceEducationalInstitutionForm'
import MultipleChoiceInstructionalProgramForm from './questiontypes/MultipleChoiceInstructionalProgramForm'
import FileQuestionForm from './questiontypes/FileQuestionForm'
import SurveyCreationForm from './SurveyCreationForm'
import MultipleChoiceClusterForm from './questiontypes/MultipleChoiceClusterForm'

import { replaceVariables } from '../../../actions/planning/assignments'
import { listStatesInUS } from '../../../actions'

class SurveyQuestionList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSubmitting: false,
      submittingRow: null
    }
    this.generateHeader = this.generateHeader.bind(this)
    this.updatePosition = this.updatePosition.bind(this)
  }

  generateHeader() {
    if (this.props.renameTitleActive) {
      return (
        <div className="with-border">
          <SurveyCreationForm
            onSave={d => {
              this.props.onRenameSurvey(d)
              //this.props.dispatch(saveNewSurvey(d)).then((s) => browserHistory.push(`/admin/survey/edit/${s.id}`))
            }}
            onCancel={this.props.onCancelRenameSurvey}
            canCreateShared={!this.props.isUserPremium}
          />
        </div>
      )
    }

    return (
      <div>
        <Link
          to={`/survey/${this.props.selected.id}`}
          className="btn btn-default no-style pull-right"
          style={{ marginBottom: '15px' }}
          onlyActiveOnIndex>
          <i className="eye"></i> {t`Preview`}
        </Link>
        <Link
          to={`/admin/survey/responses/${this.props.selected.id}`}
          className="btn btn-default no-style pull-right">
          <i className="report"></i> {t`Results`}
        </Link>
        <br className="clear" />
        <div className="with-border note-color">
          <h3>
            {replaceVariables(this.props.selected.name)}{' '}
            <a
              href="javascript:void(0)"
              className="pull-right btn btn-default no-style"
              onClick={() => this.props.onSelectSurveyToRename(this.props.selected)}>
              <i className="edit"></i> {t`Edit`}
            </a>
          </h3>
          <p>{replaceVariables(this.props.selected.description)}</p>
        </div>
      </div>
    )
  }

  updatePosition = (newPos, question) => {
    this.setState({ isSubmitting: true, submittingRow: question.id })
    this.props
      .onMoveQuestion(this.props.selected.id, question.id, newPos)
      .then(() => {
        this.setState({ isSubmitting: false, submittingRow: null })
      })
      .catch(() => {
        this.setState({ isSubmitting: false, submittingRow: null })
      })
  }

  wrapWith = (popover, cond, ns) => {
    if (cond) {
      return (
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="right"
          overlay={popover}
          rootClose={true}>
          {ns}
        </OverlayTrigger>
      )
    }

    return ns
  }

  upPop = (
    <Popover id="move-question-up-popover">{t`Move this question up one`}</Popover>
  )

  downPop = (
    <Popover id="move-question-down-popover">{t`Move this question down one`}</Popover>
  )

  lookupTypeName = typeId => {
    switch (typeId) {
      case 1:
        return t`Text Question`
      case 2:
        return t`Multiple Choice Question`
      case 3:
        return t`Rating Question`
      case 4:
        return t`Multiple Choice Occupation Question`
      case 5:
        return t`Multiple Choice Instructional Program Question`
      case 6:
        return t`Multiple Choice Educational Institution Question`
      case 7:
        return t`File Upload Question`
      case 8:
        return t`Multiple Choice Cluster Question`
    }
  }

  optsForCollege = () => {
    return {
      collegeSizeOptions: [
        {
          id: 100,
          label: t`Any Size`
        },
        {
          id: 1,
          label: `<1,000`
        },
        {
          id: 2,
          label: `1,000 - 4,999`
        },
        {
          id: 3,
          label: `5,000 - 9,999`
        },
        {
          id: 4,
          label: `10,000 - 19,999`
        },
        {
          id: 5,
          label: `20,000+`
        }
      ],
      studentBodyOptions: [
        {
          id: 100,
          label: t`Any Size`
        },
        {
          id: 1,
          label: `<1,000`
        },
        {
          id: 2,
          label: `1,000 - 4,999`
        },
        {
          id: 3,
          label: `5,000 - 9,999`
        },
        {
          id: 4,
          label: `10,000 - 19,999`
        },
        {
          id: 5,
          label: `20,000+`
        }
      ],
      stateOptions: listStatesInUS()
    }
  }

  render() {
    const {
      selected,
      onMoveQuestion,
      unselectForEdit,
      onSaveQuestion,
      onRenameSurvey,
      renameTitleActive,
      onSelectSurveyToRename,
      selectedQuestion,
      onSelectQuestion,
      onDeleteQuestion,
      onCancelRenameSurvey,
      handleSurveyNameChange,
      onAddToArray,
      onRemoveFromArray,
      onMoveInArray,
      onGetModel
    } = this.props
    const genListing = () => {
      return (
        <div>
          {this.generateHeader()}
          <ul
            className={`task-listing-list ${
              this.state.isSubmitting ? 'submitting' : 'notsubmitting'
            }`}
            style={{
              listStyle: 'none',
              padding: 4,
              opacity: this.state.isSubmitting ? '.6' : 'initial'
            }}>
            {selected.questions.map((question, rowIdx) => {
              const prvAttrs =
                rowIdx === 0
                  ? { disabled: true, style: { opacity: 0.3 } }
                  : { href: 'javascript:void(0)' }
              const nxtAttrs =
                rowIdx + 2 > selected.questions.length
                  ? { disabled: true, style: { opacity: 0.3 } }
                  : { href: 'javascript:void(0)' }

              return (
                <li
                  className="hoverable"
                  style={{
                    overflow: 'hidden',
                    maxHeight: this.state.submittingRow === question.id ? '5px' : ''
                  }}
                  key={`surveyRow${rowIdx}`}>
                  <div className="pos">
                    {this.wrapWith(
                      this.downPop,
                      rowIdx < selected.questions.length - 1,
                      <a
                        {...nxtAttrs}
                        onClick={e => {
                          e.preventDefault()
                          this.updatePosition(rowIdx + 1, question)
                        }}>
                        <img
                          src={pagearrow}
                          alt={t`Down facing arrow to go to move item down`}
                          style={{
                            width: '15px',
                            marginTop: '1rem',
                            marginLeft: '10px',
                            transform: 'rotate(90deg)'
                          }}
                        />
                      </a>
                    )}

                    {this.wrapWith(
                      this.upPop,
                      rowIdx > 0,
                      <a
                        {...prvAttrs}
                        onClick={e => {
                          e.preventDefault()
                          this.updatePosition(rowIdx - 1, question)
                        }}>
                        <img
                          src={pagearrow}
                          alt={t`Up facing arrow to go to move item up`}
                          style={{
                            width: '15px',
                            marginTop: '1rem',
                            marginLeft: '10px',
                            transform: 'rotate(270deg)'
                          }}
                        />
                      </a>
                    )}
                  </div>
                  <a
                    href="#"
                    className="task-btn"
                    onClick={() => onSelectQuestion(question)}>
                    <p>{replaceVariables(question.text)}</p>
                    <p style={{ color: '#777', fontStyle: 'italic', fontSize: '.9em' }}>
                      {this.lookupTypeName(question.questionTypeId)}
                    </p>
                  </a>
                  <div className="actn">
                    <a
                      onClick={() => {
                        if (confirm(t`Are you sure you want to delete?`)) {
                          onDeleteQuestion(selected, question)
                        }
                      }}
                      href="javascript://"
                      className="delete pull-right">
                      <span>{t`Delete`}</span>
                    </a>
                  </div>
                </li>
              )
            })}
          </ul>

          <div style={{ paddingTop: '25px' }} className="text-center">
            <div className="btn-group buttons">
              <button
                aria-expanded="false"
                aria-haspopup="true"
                data-toggle="dropdown"
                className="btn btn-default dropdown-toggle no-style btn-lg"
                type="button">
                <i className="add"></i> {t`Add Question`} <span className="caret"></span>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a
                    href="javascript://"
                    onClick={() =>
                      onSelectQuestion({
                        questionTypeId: 1,
                        validateInput: 1
                      })}>
                    {t`Add text question`}
                  </a>
                </li>
                <li>
                  <a
                    href="javascript://"
                    onClick={() => onSelectQuestion({ questionTypeId: 2 })}>
                    {t`Add multiple choice question`}
                  </a>
                </li>
                <li>
                  <a
                    href="javascript://"
                    onClick={() => onSelectQuestion({ questionTypeId: 3 })}>
                    {t`Add rating question`}
                  </a>
                </li>
                <li>
                  <a
                    href="javascript://"
                    onClick={() => onSelectQuestion({ questionTypeId: 4 })}>
                    {t`Add multiple choice occupation question`}
                  </a>
                </li>
                <li>
                  <a
                    href="javascript://"
                    onClick={() => onSelectQuestion({ questionTypeId: 5 })}>
                    {t`Add multiple choice instructional program question`}
                  </a>
                </li>
                <li>
                  <a
                    href="javascript://"
                    onClick={() =>
                      onSelectQuestion({ questionTypeId: 6, ...this.optsForCollege() })}>
                    {t`Add multiple choice educational institution question`}
                  </a>
                </li>
                <li>
                  <a
                    href="javascript://"
                    onClick={() => onSelectQuestion({ questionTypeId: 8 })}>
                    {t`Add multiple choice cluster question`}
                  </a>
                </li>
                <li>
                  <a
                    href="javascript://"
                    onClick={() => onSelectQuestion({ questionTypeId: 7 })}>
                    {t`Add file upload question`}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <button
            className="btn btn-primary no-style"
            style={{ marginTop: '30px' }}
            onClick={() => unselectForEdit()}>
            {t`Back to list`}
          </button>
        </div>
      )
    }
    const onSave = form => {
      console.log(form)
      onSaveQuestion(selected, form)

      return false
    }
    const genQuestionForm = () => {
      switch (selectedQuestion.questionTypeId) {
        case 2:
          return (
            <MultipleChoiceQuestionForm
              key="multichoice"
              onSave={onSave}
              onMoveInArray={onMoveInArray}
              onGetModel={onGetModel}
              onRemoveFromArray={onRemoveFromArray}
              onAddToArray={onAddToArray}
              onCancel={() => onSelectQuestion(null)}
            />
          )
        case 3:
          return (
            <RatingQuestionForm
              key="rating"
              onGetModel={onGetModel}
              onSave={onSave}
              onCancel={() => onSelectQuestion(null)}
            />
          )
        case 4:
          return (
            <MultipleChoiceOccupationForm
              key="multioccupation"
              onCancel={() => onSelectQuestion(null)}
              onSave={onSave}
              clusterOptions={selectedQuestion.clusterOptions}
              interestOptions={selectedQuestion.interestOptions}
            />
          )
        case 5:
          return (
            <MultipleChoiceInstructionalProgramForm
              key="multiinstructional"
              onSave={onSave}
              onCancel={() => onSelectQuestion(null)}
            />
          )
        case 6:
          return (
            <MultipleChoiceEducationalInstitutionForm
              key="multieducational"
              onCancel={() => onSelectQuestion(null)}
              onSave={onSave}
              studentBodyOptions={selectedQuestion.studentBodyOptions}
              stateOptions={selectedQuestion.stateOptions}
              collegeSizeOptions={selectedQuestion.collegeSizeOptions}
            />
          )
        case 7:
          return (
            <FileQuestionForm
              key="file"
              onCancel={() => onSelectQuestion(null)}
              onSave={onSave}
            />
          )
        case 8:
          return (
            <MultipleChoiceClusterForm
              key="multicluster"
              onSave={onSave}
              onCancel={() => onSelectQuestion(null)}
            />
          )

        default:
          return (
            <TextQuestionForm
              key="textquestion"
              onCancel={() => onSelectQuestion(null)}
              onSave={onSave}
              userOptions={selectedQuestion.userDefaultOptions}
              validationOptions={selectedQuestion.validationOptions}
            />
          )
      }
    }

    if (selectedQuestion) {
      return genQuestionForm()
    }

    return genListing()
  }
}
export default SurveyQuestionList
